import { ASSET_PREFIX, colors } from "utils/constants";
import $ from "jquery";
import { useEffect, useState } from "react";
import Chevron from "components/Chevron";
import { RafflePrizeGroup } from 'components/raffle/RafflePrizeGroup'

export const EntriesTab = {
  WEEKLY_DRAW: 0,
  RAFFLE: 1,
  UNBOXED: 2,
  COVID_RELIEF: 3,
  HARDWIRED: 4,
  ON_TOUR: 5,
  DAILY_DRAW: 6,
  DAILY_POUND_RAFFLE: 7,
  TOKEN_TOWN: 8,
};

export const entriesTabForRafflePrizeGroup = (rafflePrizeGroup) => {
  switch (rafflePrizeGroup) {
    case RafflePrizeGroup.TRIPS:
      return EntriesTab.RAFFLE;

    case RafflePrizeGroup.GOODIEBOX:
      return EntriesTab.UNBOXED;

    case RafflePrizeGroup.COVID_RELIEF:
      return EntriesTab.COVID_RELIEF;

    case RafflePrizeGroup.HARDWIRED:
      return EntriesTab.HARDWIRED;

    case RafflePrizeGroup.ON_TOUR:
      return EntriesTab.ON_TOUR;

    case RafflePrizeGroup.DAILY_POUND:
      return EntriesTab.DAILY_POUND_RAFFLE;

    default:
      console.log(`No entries tab for raffle prize group: ${rafflePrizeGroup}`);
  }
};

export const rafflePrizeGroupForEntriesTab = (entriesTab) => {
  switch (entriesTab) {
    case EntriesTab.RAFFLE:
      return RafflePrizeGroup.TRIPS;

    case EntriesTab.UNBOXED:
      return RafflePrizeGroup.GOODIEBOX;

    case EntriesTab.COVID_RELIEF:
      return RafflePrizeGroup.COVID_RELIEF;

    case EntriesTab.HARDWIRED:
      return RafflePrizeGroup.HARDWIRED;

    case EntriesTab.ON_TOUR:
      return RafflePrizeGroup.ON_TOUR;

    case EntriesTab.DAILY_POUND_RAFFLE:
      return RafflePrizeGroup.DAILY_POUND;

    default:
      console.log(`No raffle prize group for entries tab: ${entriesTab}`);
  }
};

export const Tab = ({ tab, titleComponent, selected, onSelect, width }) => (
  <div className={`tab${selected ? ' active' : ''}`} onClick={() => onSelect(tab)}>
    <p style={{ marginBottom: '0.3em', fontWeight: 'bold' }}>
      {titleComponent}
    </p>

    { selected &&
      <img src={`${ASSET_PREFIX}/images/raffle/down-arrow.svg`} style={{ position: 'absolute', bottom: 0, left: 'calc(50% - 6.5px)', height: '13px' }} />
    }

    <style jsx>{`
      .tab {
        position: relative;
        display: flex;
        flex-direction: column;
        background-color: #B9B9B9;
        padding: 1em 1em 1em 1em;
        width: ${width};
        min-width: 130px;
        cursor: pointer;
        transition: 0.2s;
        justify-content: center;
        box-shadow: inset 0 -7px 9px -7px rgba(0,0,0,0.4);
        flex-grow: 1;
        flex-shrink: 1;
        flex-basis: 0px;
      }
      
      @media(max-width: 420px) {
        .tab {
          font-size: 0.9em;
        }
      }
      
      @media(max-width: 370px) {
        .tab {
          font-size: 0.8em;
        }
      }
      
      .tab:hover:not(.active) {
        background-color: #A8A8A8;
        transition: 0.2s;
      }
      
      .tab.active {
        cursor: default;
        background-color: white;
        border-top-left-radius: 6px;
        border-top-right-radius: 6px;
        text-shadow: 0 0 4px #00FFC1;
        box-shadow: none;
      }
    `}</style>
  </div>
);

const EntriesTabBar = ({ selectedTab, onSelect, style, hiddenSections = [] }) => {
  const tabWidth = `${100 / (Object.keys(EntriesTab).length - hiddenSections.length)}%`;

  const [leftScrollButtonHidden, setLeftScrollButtonHidden] = useState(true);
  const [rightScrollButtonHidden, setRightScrollButtonHidden] = useState(true);

  const scrollTabBar = (dx) => {
    if (typeof window !== 'undefined') {
      $(`#tabBar`).animate({ scrollLeft: dx }, 300);
    }
  };

  let bar, scrollWidth;

  const showOrHideScrollButtonsIfAppropriate = () => {
    if (typeof bar === 'undefined') {
      bar = $('#tabBar');
      scrollWidth = bar[0].scrollWidth - bar.width();
    }

    setLeftScrollButtonHidden(bar.scrollLeft() < 2);
    setRightScrollButtonHidden(scrollWidth - bar.scrollLeft() < 2);
  };

  useEffect(showOrHideScrollButtonsIfAppropriate, []);

  return (
    <div className='container' style={{ width: '100%', position: 'relative' }}>
      <div
        className='bar'
        id='tabBar'
        onScroll={showOrHideScrollButtonsIfAppropriate}
        style={style}
      >
        { !leftScrollButtonHidden &&
          <button className='scrollButton' onClick={() => scrollTabBar('-=200px')} style={{ position: 'absolute', height: '100%', left: 0, zIndex: 4, alignSelf: 'center', background: 'linear-gradient(to right, rgba(176,176,176,1), rgba(176,176,176,1), rgba(176,176,176,0))', borderRadius: 0, paddingLeft: '0.4em' }}>
            <Chevron
              direction='left'
              style={{
                color: colors.primaryBrandGray,
                fontSize: '1.6em',
                margin: 0
              }}
            />
          </button>
        }

        { !hiddenSections.includes(EntriesTab.WEEKLY_DRAW) &&
        <Tab
          tab={EntriesTab.WEEKLY_DRAW}
          titleComponent={<>WEEKLY <strong>DRAW</strong></>}
          onSelect={onSelect}
          selected={selectedTab === 0}
          width={tabWidth}
        />
        }

        { !hiddenSections.includes(EntriesTab.RAFFLE) &&
        <Tab
          tab={ EntriesTab.RAFFLE }
          titleComponent={ <>TRAVEL RAFFLE</> }
          onSelect={ onSelect }
          selected={ selectedTab === 1 }
          width={tabWidth}
        />
        }

        { !hiddenSections.includes(EntriesTab.UNBOXED) &&
        <Tab
          tab={ EntriesTab.UNBOXED }
          titleComponent={ <>UNBOXED</> }
          onSelect={ onSelect }
          selected={ selectedTab === 2 }
          width={tabWidth}
        />
        }

        { !hiddenSections.includes(EntriesTab.COVID_RELIEF) &&
        <Tab
          tab={ EntriesTab.COVID_RELIEF }
          titleComponent={ <>CHARITY RAFFLE</> }
          onSelect={ onSelect }
          selected={ selectedTab === 3 }
          width={tabWidth}
        />
        }

        { !hiddenSections.includes(EntriesTab.HARDWIRED) &&
        <Tab
          tab={ EntriesTab.HARDWIRED }
          titleComponent={ <>HARDWIRED</> }
          onSelect={ onSelect }
          selected={ selectedTab === 4 }
          width={tabWidth}
        />
        }

        { !hiddenSections.includes(EntriesTab.ON_TOUR) &&
        <Tab
          tab={ EntriesTab.ON_TOUR }
          titleComponent={ <>ON <strong>TOUR</strong></> }
          onSelect={ onSelect }
          selected={ selectedTab === 5 }
          width={tabWidth}
        />
        }

        { !hiddenSections.includes(EntriesTab.DAILY_DRAW) &&
        <Tab
          tab={ EntriesTab.DAILY_DRAW }
          titleComponent={ <>DAILY <strong>DRAW</strong></> }
          onSelect={ onSelect }
          selected={ selectedTab === 6 }
          width={tabWidth}
        />
        }

        { !rightScrollButtonHidden &&
          <button className='scrollButton' onClick={() => scrollTabBar('+=200px')} style={{ position: 'absolute', height: '100%', right: 0, zIndex: 4, alignSelf: 'center', background: 'linear-gradient(to right, rgba(176,176,176,0), rgba(176,176,176,1), rgba(176,176,176,1))', borderRadius: 0, paddingRight: '0.4em' }}>
            <Chevron
              direction='right'
              style={{
                color: colors.primaryBrandGray,
                fontSize: '1.6em',
                margin: 0
              }}
            />
          </button>
        }

        <style jsx>{`
        .bar {
          display: flex;
          font-family: 'Montserrat', sans-serif !important;
          text-align: center;
          font-weight: bold;
          letter-spacing: 0.3em;
          text-transform: uppercase;
          width: 100%;
          background-color: #B9B9B9;
          overflow-x: auto;
          overflow-y: hidden;
        }
        
        .bar::-webkit-scrollbar {
          display: none;
        }
      `}</style>
      </div>
    </div>
  );
};

export default EntriesTabBar;
